import { splitAccessorPath } from '../../../core/utils/accessors/split-accessor-path.js';
import type { DataTableV2RowData } from '../public.api.js';

/**
 * This function converts a JSONpath like string to an accessor funciton.
 * @internal
 */
export function makeAccessorFunction<TData extends DataTableV2RowData, TValue>(
  accessor: string,
): (row: TData) => TValue {
  const accessPath = splitAccessorPath(accessor);

  return function (row: TData) {
    let currentObj = row;
    for (const accessPathPart of accessPath) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      currentObj = ((currentObj as any) ?? {})[accessPathPart];
    }

    return currentObj as unknown as TValue;
  };
}
